<script>
import { mapGetters } from 'vuex'
import api from '@services/api'

export default {
  name: 'WithAllLayouts',
  props: {
    type: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      allLayouts: [],
      layoutsLoading: false,
    }
  },
  computed: {
    ...mapGetters('auth', ['loggedIn']),
    ...mapGetters('site', ['getLocationSummary']),
  },
  watch: {
    loggedIn: {
      handler(val) {
        if (val) this.loadAllLayouts()
      },
      immediate: true,
    },
  },
  methods: {
    async loadAllLayouts() {
      const locations = this.getLocationSummary
      if (!locations || !locations.length) return
      this.layoutsLoading = true
      try {
        const params = this.type ? { type: this.type } : {}
        const results = await Promise.all(
          locations.map((loc) =>
            api
              .get(`/locations/${loc.id}/layouts`, { params })
              .then((r) => ({
                locationTitle: loc.title,
                locationSlug: loc.slug,
                layouts: r.data || [],
              }))
              .catch((err) => {
                console.error(err)
                return null
              })
          )
        )
        this.allLayouts = results.filter(Boolean)
      } finally {
        this.layoutsLoading = false
      }
    },
  },
  render() {
    return this.$scopedSlots.default({
      allLayouts: this.allLayouts,
      layoutsLoading: this.layoutsLoading,
    })
  },
}
</script>
